import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import { useCatalogSearchIndex } from '@segment/contexts/catalogIndex';
export var attributesToFetch = ["contentType", "slug", "name", "logo", "fastGrowingCompany", "type"];
export var fetchFastGrowingCompanies = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var catalogIndex, amount, filters, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            catalogIndex = _ref.catalogIndex, amount = _ref.amount;
            filters = "fastGrowingCompany=1";
            _context.next = 4;
            return catalogIndex.search("", {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: false,
              page: 0,
              hitsPerPage: amount,
              filters: filters
            });

          case 4:
            data = _context.sent;
            return _context.abrupt("return", data.hits);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchFastGrowingCompanies(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var createFastGrowingCompaniesQuery = function createFastGrowingCompaniesQuery(catalogIndex, _ref3) {
  var amount = _ref3.amount;
  return [["developerCenter/fastGrowingCompaniesQuery", amount !== null && amount !== void 0 ? amount : null], function () {
    return fetchFastGrowingCompanies({
      catalogIndex: catalogIndex,
      amount: amount
    });
  }];
};
export var useFastGrowingCompaniesQuery = createQueryHook(createFastGrowingCompaniesQuery, useCatalogSearchIndex);